import React, { useEffect } from "react";
import { LOGO_URL } from "../lib/constants";

const GOLD = "#c9a227";
const BLACK = "#0a0a0a";
const STRIPE_SINGLE_30 = "https://buy.stripe.com/aFa5kE6PG4q40YBbyZ5Vu02"; // $29.99 direct Stripe — pay-first flow (redirects to /thank-you?sku=single)

const getCookie = (n) => {
    if (typeof document === "undefined") return null;
    const v = document.cookie.match("(^|;)\\s*" + n + "\\s*=\\s*([^;]+)");
    return v ? v.pop() : null;
};

/**
 * /watch — Single-purpose LP for the 3-client mid-session video.
 * Used in the mother email as a clean, focused "watch this" destination.
 * Fires Pixel ViewContent + Reserve CTA goes direct to Stripe (pay-first).
 */
const Watch = () => {
    useEffect(() => {
        document.title = "Watch — 3 Clients · Mid-Session · The Reset Sanctuary";
        if (typeof window !== "undefined" && typeof window.fbq === "function") {
            try {
                window.fbq("track", "ViewContent", {
                    content_name: "3 Clients Mid-Session Proof Video",
                    content_category: "Proof Video LP",
                });
            } catch (e) {}
        }
    }, []);

    const handleReserveClick = (e) => {
        if (e && e.preventDefault) e.preventDefault();
        const eventId = `watch-ic-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
        if (typeof window !== "undefined" && typeof window.fbq === "function") {
            try {
                window.fbq("track", "InitiateCheckout", {
                    content_name: "Sleep & Anxiety Broadcast",
                    value: 29.99,
                    currency: "USD",
                    eventID: eventId,
                });
            } catch (err) {}
        }
        if (typeof window !== "undefined" && process.env.REACT_APP_BACKEND_URL) {
            try {
                fetch(`${process.env.REACT_APP_BACKEND_URL}/api/meta/capi`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        event_name: "InitiateCheckout",
                        event_source_url: window.location.href,
                        event_id: eventId,
                        fbp: getCookie("_fbp"),
                        fbc: getCookie("_fbc"),
                        client_user_agent: navigator.userAgent,
                        value: 29.99,
                        currency: "USD",
                        content_name: "Sleep & Anxiety Broadcast",
                    }),
                    keepalive: true,
                }).catch(() => {});
            } catch (err) {}
        }
        // Wrap fbp+fbc+ua into client_reference_id for Stripe webhook → CAPI EMQ inheritance
        let url = STRIPE_SINGLE_30;
        try {
            const fbp = getCookie("_fbp");
            const fbc = getCookie("_fbc");
            const ua = (typeof navigator !== "undefined" ? navigator.userAgent : "").slice(0, 80);
            const payload = { fbp, fbc, ua, t: Date.now() };
            const json = JSON.stringify(payload);
            const crid = btoa(unescape(encodeURIComponent(json)))
                .replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
            url = `${STRIPE_SINGLE_30}?client_reference_id=${crid}`;
        } catch (err) { /* fallback */ }
        if (typeof window !== "undefined") window.open(url, "_blank", "noopener,noreferrer");
    };

    return (
        <main data-testid="watch-page" style={{ backgroundColor: BLACK, color: "#fff", fontFamily: "Inter, sans-serif", minHeight: "100vh", padding: "60px 24px" }}>
            <div style={{ maxWidth: 720, margin: "0 auto", textAlign: "center" }}>
                <img src={LOGO_URL} alt="The Reset Sanctuary" style={{ width: 56, margin: "0 auto 22px", display: "block" }} />
                <p style={{ color: GOLD, fontSize: 11, letterSpacing: "0.34em", textTransform: "uppercase", fontWeight: 600, margin: "0 0 16px" }}>
                    Three Clients · Mid-Session · No Words Needed
                </p>
                <h1 className="font-serif" style={{ fontSize: "clamp(28px, 4.5vw, 38px)", fontWeight: 400, margin: "0 0 28px", lineHeight: 1.18, letterSpacing: "-0.015em" }}>
                    They lay down.<br/><span style={{ color: GOLD, fontStyle: "italic" }}>Then they slept.</span>
                </h1>

                <video
                    controls
                    playsInline
                    preload="metadata"
                    poster="/brochure-assets/testimonials/trs-mix-poster.jpg"
                    style={{ width: "100%", aspectRatio: "9 / 16", maxHeight: 720, objectFit: "cover", border: `1px solid rgba(201,162,39,0.25)`, backgroundColor: "#000", display: "block", margin: "0 auto 28px" }}
                    data-testid="watch-video"
                >
                    <source src="/brochure-assets/testimonials/trs-3-clients-mix.mp4" type="video/mp4" />
                </video>

                <p style={{ color: "#bbb", fontSize: 15.5, lineHeight: 1.7, margin: "0 0 30px", fontWeight: 300 }}>
                    Sachin · Martyn · Daniel. Three live sessions. Three real humans pulled out of fight-or-flight by frequencies. <em style={{ color: GOLD }}>The work doesn't need them to do anything. Physics takes over.</em>
                </p>

                <a
                    href={STRIPE_SINGLE_30}
                    onClick={handleReserveClick}
                    data-testid="watch-cta"
                    style={{ display: "inline-block", padding: "16px 36px", backgroundColor: GOLD, color: BLACK, textDecoration: "none", fontSize: 13, letterSpacing: "0.22em", textTransform: "uppercase", fontWeight: 700 }}
                >
                    Reserve Your Live Session — $29.99
                </a>
                <p style={{ color: "#777", fontSize: 12, letterSpacing: "0.18em", textTransform: "uppercase", margin: "16px 0 0", fontWeight: 500 }}>
                    Secure Stripe checkout · Pick your slot after payment
                </p>
            </div>
        </main>
    );
};

export default Watch;
